module.exports = __webpack_public_path__ + "media/img/business-before-footer-9a69003e.svg";